import styled, { css } from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';

export const PaginationWrapper = styled.div`
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  display: flex;
  justify-content: center;
  font-size: 16px;
  ${(props) => {
    return `
      @media ${props.theme.mediaQuery.medium} {
        font-size: 20px;
      }
      @media ${props.theme.mediaQuery.large} {
        font-size: 24px;
      }
    `;
  }};
`;

export const PaginationDropDown = styled.div`
  margin: 0 25px;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.DARK};
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    margin: 0;
  }
`;

const PaginatorStyles = css`
  background: transparent;
  position: relative;
  &:not(:disabled) {
    cursor: pointer;
  }
  border: 0;
  font-size: inherit;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
  color: ${(props) => props.theme.colors.PRIMARY.DARK};
  &:disabled {
    color: hsl(0, 0%, 80%);
  }
  @media (hover: hover) {
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      color: ${(props) => props.theme.colors.PRIMARY.GRAY};
    }
  }
  &.next::after {
    content: ' ';
    border: solid;
    border-color: inherit;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 6px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin: auto 10px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      position: absolute;
      right: -23px;
      top: 13px;
    }
  }

  &.prev::before {
    content: ' ';
    border: solid;
    border-color: inherit;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 6px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin: auto 5px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      position: absolute;
      left: -19px;
      top: 13px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-right: 10px;
    }
  }
`;

export const PaginatorButton = styled.button`
  ${PaginatorStyles}
`;

export const PaginatorAnchor = styled(Anchor)`
  ${PaginatorStyles}
  padding: 1px 6px;
  display: flex;
  align-items: center;
`;
